let deletePipelineCallback: (() => void) | null = null

export function registerDeletePipelineCallback(cb: (() => void) | null) {
  deletePipelineCallback = cb
}

export function getDeletePipelineCallback(): (() => void) | null {
  return deletePipelineCallback
}
